import { render } from "./farmingDetail.vue?vue&type=template&id=53f9e412&scoped=true&ts=true"
import script from "./farmingDetail.vue?vue&type=script&lang=ts"
export * from "./farmingDetail.vue?vue&type=script&lang=ts"

import "./farmingDetail.vue?vue&type=style&index=0&id=53f9e412&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f9e412"]])

export default __exports__